import React from 'react';
import { CASH_DEPOSIT_PERMISSION } from 'pages/CashDeposit/utils/permissions';

const DefaultPage = React.lazy(() => import('pages/CashDeposit/pages/DefaultPage'));
const FormPage = React.lazy(() => import('pages/CashDeposit/pages/FormPage'));

const cashDepositRoutes = [
  {
    path: '/cash-deposit',
    exact: true,
    name: 'Nộp tiền vào ngân hàng',
    function: [CASH_DEPOSIT_PERMISSION.VIEW, CASH_DEPOSIT_PERMISSION.VIEW_ALL, CASH_DEPOSIT_PERMISSION.EDIT],
    any: true,
    component: DefaultPage,
  },
  {
    path: '/cash-deposit/add',
    exact: true,
    name: 'Tạo phiếu nộp tiền',
    function: CASH_DEPOSIT_PERMISSION.ADD,
    component: FormPage,
  },
  {
    path: '/cash-deposit/edit/:id',
    exact: true,
    name: 'Sửa phiếu nộp tiền',
    function: CASH_DEPOSIT_PERMISSION.EDIT,
    requireAssigned: true,
    component: FormPage,
  },
  {
    path: '/cash-deposit/detail/:id',
    exact: true,
    name: 'Chi tiết phiếu nộp tiền',
    function: [CASH_DEPOSIT_PERMISSION.VIEW, CASH_DEPOSIT_PERMISSION.VIEW_ALL, CASH_DEPOSIT_PERMISSION.EDIT],
    any: true,
    component: FormPage,
  },
];

export default cashDepositRoutes;
